const NUP_CREATION_ERROR_MESSAGE =
    "Não foi possível gerar o número da solicitação. Tente novamente mais tarde.";

const GENERIC_API_ERROR_MESSAGE =
    "Não foi possível concluir a solicitação. Tente novamente mais tarde.";

function sanitizeApiMessage(message: string): string {
    const hasHtmlContent = /<\/?[a-z][\s\S]*>/i.test(message);
    const isNupCreationError = message.includes("Erro inesperado ao criar nup");

    if (isNupCreationError) {
        return NUP_CREATION_ERROR_MESSAGE;
    }

    return hasHtmlContent ? GENERIC_API_ERROR_MESSAGE : message;
}

export default function extractInnerMessage(message: any): string {
    const errMessage = message?.response?.data?.message || String(message);

    const matchMessage = String(errMessage).match(/"message"\s*:\s*"([^"]*)"/);
    return sanitizeApiMessage(matchMessage ? matchMessage[1] : String(errMessage));
}

// tenta extrair messagem de erro lançada pelo script, para mostrar mensagem mais amigavel para o usuario
export function extractApiScriptErrorMessage(message: any): string {
    const regex = /^Unable to evaluate script while executing activity '[^']+' in the process definition with id '[^']+':Error:\s*(.*?)\s*in <eval>/;

    const errMessage = message?.response?.data?.message || String(message);
  
    const matchMessage = String(errMessage).match(regex);
    return matchMessage ? matchMessage[1] : errMessage;
}
